import { UserTable } from 'src/features/userManagement/components';

const Users = () => {
    return <UserTable />;
};

export { Users };
